<template>
  <div class="refund-cancellation-component">
    <div class="section-2">
      <el-row>
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">&nbsp; </el-col>

        <el-col :xs="24" :sm="20" :md="20" :lg="20" :xl="20">
          <div class="">
            <p>
              We thank you and appreciate your subscription to our website.
              Please read the policy, conditions, and process carefully as they
              will give you important information and guidelines about your
              rights and obligations as our subscriber, concerning the
              subscription you make on our website. We make every effort to have
              our website meet your expectations
            </p>
            <h1>StockAnts has no refund policy.</h1>
          </div>

        </el-col>

        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">&nbsp; </el-col>
      </el-row>
    </div>
  </div> </template
><script>
export default {
  name: "RefundAndCancellationComponent",

  components: {},

  mixins: [],

  data() {
    return {};
  },

  methods: {},

  computed: {},
};
</script>
<style lang="scss" scoped>
.refund-cancellation-component {
  .section-2 {
    .special-sec {
      margin: 60px 0;
    }
    h1 {
      font-size: 1.6rem;
      font-weight: 600;
      color: #25246a;
    }
    p {
      font-size: 0.9rem;
      color: #6d6a6a;
    }
    ul {
      list-style: none;
      li {
        font-size: 0.9rem;
        margin: 10px 0;
        color: #6d6a6a;
      }
      li::before {
        content: "\2022";
        color: #322e79;
        font-weight: bold;
        width: 1em;
        margin-left: -1em;
        font-size: 45px;
        position: relative;
        margin-right: 25px;
        top: 7px;
      }
    }
  }

  @media screen and (max-width: 876px) {
    .section-2 {
      padding: 0 70px;
    }
  }
  @media screen and (max-width: 600px) {
    .section-2 {
      padding: 0 35px;
    }
  }
  @media screen and (max-width: 450px) {
    .section-2 {
      padding: 0 20px;
    }
  }
}
</style>
